/* src/app/components/user/user-list.component.css */
/*# sourceMappingURL=user-list.component.css.map */
